import { TaxScenario } from "./tax_scenario";

/**
 * Schedule D
 */
export function capitalGainsAndLosses(taxScenario: TaxScenario): number {
  return Math.max(-3000, taxScenario.shortTermCapitalGain + taxScenario.longTermCapitalGain);
}
